import React from "react";
import ButtonWithLoading from "../ButtonWithLoading";
import {changeProfileInput, storeProfile} from "../../../actions/actionCreators";
import {connect} from "react-redux";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import i18n from "../../../i18nextInitiator";
import makeStyles from "@material-ui/core/styles/makeStyles";

const t = i18n.getFixedT('fa', 'general');

const mapStateToProps = state => ({...state.auth});

const useStyles = makeStyles(theme => ({
    root: {
        padding: "20px",
        maxWidth: 600,
        margin: "0 auto",
        '& > *': {
            margin: ".8rem 0"
        },
        '& button': {
            boxShadow: "unset"
        },
        '& *:focus': {
            outline: 0
        }
    },
}))

const Profile = (props) => {

    const classes = useStyles()

    const {
        storingProfile,
        nameError,
        emailError,
        disableReferral,
        profile: {
            name = '',
            phone = '',
            email = '',
            share_code = ''
        } = {}
    } = props

    return <Grid className={classes.root}>

        <TextField fullWidth variant={"outlined"}
                   label={t("auth.names")}
                   name={"name"}
                   onChange={changeProfileInput}
                   value={name}
                   error={nameError}
        />

        <TextField fullWidth variant={"outlined"}
                   label={t("auth.phone-number")}
                   name={"phone"}
                   value={phone}
        />

        <TextField fullWidth variant={"outlined"}
                   label={t("email")}
                   name={"email"}
                   onChange={changeProfileInput}
                   value={email}
                   error={emailError}
                   helperText={emailError ? t("validation.wrong", {field: t('email')}) : ''}
        />

        <TextField fullWidth variant={"outlined"}
                   label={t("auth.referral-code")}
                   name={"share_code"}
                   onChange={changeProfileInput}
                   value={share_code}
                   disabled={disableReferral}
        />

        <ButtonWithLoading
            action={storeProfile}
            loading={storingProfile}
        />
    </Grid>
}
export default connect(mapStateToProps)(Profile)